// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@flip/XDL/PreStyle/typography";
import { xBaseTheme } from "@flip/XDL/types";
import color, { getSystemColor } from "@flip/XDL/Utilities/color";
import { StyledTypography } from "@insite/mobius/Link";
import LinkPresentationPropsDefault from "@insite/mobius/Link/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...LinkPresentationPropsDefault,
        color: "text.link",
        hoverStyle: {
            color: getSystemColor("secondary"),
            textDecoration: "underline"
        },
        typographyProps: {
            size: 16,
            weight: fontConfig.weight.semiBold,
            css: css`
                letter-spacing: 0;
                line-height: 19px;
            `,
        },
        css: css`
            &:focus,
            &:visited {
                ${TypographyStyle}{
                    color: ${color("common.ui12")};
                }
            }
        `,
    },
} as xBaseTheme["link"];
